import { FileDownload } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import ClearIcon from "@mui/icons-material/Clear";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import RedoIcon from "@mui/icons-material/Redo";
import { DownloadIcon } from "@primer/octicons-react";
import {
  Button,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  Link,
} from "@mui/material";
import IconDownload from "components/IconDownload";
import { VisuallyHiddenInput } from "components/VisuallyHiddenInput";
import PropTypes from "prop-types";
import { useMemo, useState } from "react";
import { useRecoilValue } from "recoil";
import { SettingState } from "states";
import { API_URL_DOWNLOAD, checkUrlTep } from "utils/constants";

const allowedFileTypes = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
  "application/vnd.ms-excel", // .xls
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/bmp",
  "image/svg+xml", // image/*
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .doc, .docx
  "application/pdf", // .pdf
  "application/zip",
  "application/x-rar-compressed", // .zip, .rar
];

function AddListFile(props) {
  const {
    dataDefault,
    fileFields,
    fileDel,
    fileEditName,
    errors,
    onFileChange,
    onDelete,
    onEditName,
    onError,
    onErrorDownload,
    nameFile,
    noMedia,
  } = props;
  const settingState = useRecoilValue(SettingState);
  const acceptFileTypes = settingState["extension"].join(", ");

  const handleOnFocusFileNameChange = (index) => (e) => {
    let _err = [];
    if (errors && errors.tentepdinhkem) {
      _err = errors.tentepdinhkem;
      _err[index] = "";
    } else _err.push("");
    onError?.({ ...errors, tentepdinhkem: _err });
  };
  const handleErrorDownload = (mess) => {
    onErrorDownload?.({
      alert: true,
      message: mess,
      type: "error",
    });
  };
  const handleEditFileName = (id) => (e) => {
    let newFileEditName = { ...fileEditName };
    newFileEditName[id].tentepdinhkem = e?.target?.value;
    onEditName?.(newFileEditName);
  };
  const handelFocusEditFileName = (id) => (e) => {
    let _err = errors?.tentepdinhkemEdit;
    if (_err && errors?.tentepdinhkemEdit[id]) {
      _err[id] = "";
    }
    onError?.({ ...errors, tentepdinhkemEdit: _err });
  };
  const handleEditName = (fileId, fileName) => (e) => {
    let changeName = {
      id: fileId,
      tentepdinhkem: fileName,
    };
    onEditName?.((prev) => ({
      ...prev,
      [fileId]: changeName,
    }));
  };

  const handleToCancelEdit = (id) => (e) => {
    let newEditFile = { ...fileEditName };
    delete newEditFile[id];
    onEditName?.(newEditFile);
  };
  const handelDelFile = (fileId) => {
    onDelete?.([...fileDel, fileId]);
    let newFileEditName = { ...fileEditName };
    delete newFileEditName[fileId];
    onEditName?.(newFileEditName);
  };
  const handelRestoreFile = (fileIdRestore) => {
    const updatedFileDel = fileDel.filter((id) => id !== fileIdRestore);
    onDelete?.(updatedFileDel);
  };
  const handleFileNameChange = (event, index) => {
    const updatedFields = [...fileFields];
    updatedFields[index].filename = event.target.value;
    onFileChange?.(updatedFields);
  };
  const handleOnFocusFileChange = (index) => (e) => {
    let _err = [];
    if (errors && errors.tepdinhkemValidate) {
      _err = errors.tepdinhkemValidate;
      _err[index] = "";
    } else _err.push("");
    onError?.({ ...errors, tepdinhkemValidate: _err, tentepdinhkem: "" });
  };
  const handleFileChange = (event, index) => {
    let _err = [];
    if (errors && errors.tepdinhkemValidate) {
      _err = errors.tepdinhkemValidate;
      _err[index] = "";
    } else _err.push("");
    let _err2 = [];
    if (errors && errors.tentepdinhkem) {
      _err2 = errors.tentepdinhkem;
      _err2[index] = "";
    } else _err.push("");
    onError?.({ ...errors, tepdinhkemValidate: _err, tentepdinhkem: _err2 });
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const extensionFile = "." + selectedFile.name.split(".").pop();
      if (
        selectedFile.size / (1024 * 1024) >
        settingState["dungluong_file_upload"]
      ) {
        let _err = [];
        if (errors && errors.tepdinhkemValidate) {
          _err = errors.tepdinhkemValidate;
          _err[index] =
            "Kích thước tệp quá lớn. Tệp upload phải nhỏ hơn " +
            settingState["dungluong_file_upload"] +
            "MB.";
        } else
          _err.push(
            "Kích thước tệp quá lớn. Tệp upload phải nhỏ hơn " +
              settingState["dungluong_file_upload"] +
              "MB."
          );
        let _err2 = [];
        if (errors && errors.tentepdinhkem) {
          _err2 = errors.tentepdinhkem;
          _err2[index] = "Tên tệp không được trống";
        } else _err.push("Tên tệp không được trống");
        onError?.({
          ...errors,
          tepdinhkemValidate: _err,
          tentepdinhkem: _err2,
        });
        const updatedFields = [...fileFields];
        updatedFields[index].file = null;
        updatedFields[index].filename = null;
        onFileChange?.(updatedFields);
        return;
      }
      // Kiểm tra định dạng
      const fileTypeIsValid = allowedFileTypes.some(
        (type) => selectedFile.type == type
      );
      // const fileTypeIsValid = settingState["extension"].some(
      //   (type) => extensionFile == type
      // );
      if (!fileTypeIsValid) {
        let _err = [];
        if (errors && errors.tepdinhkemValidate) {
          _err = errors.tepdinhkemValidate;
          _err[index] = "Tệp phải có định dạng: " + acceptFileTypes;
        } else _err.push("Tệp phải có định dạng: " + acceptFileTypes);
        let _err2 = [];
        if (errors && errors.tentepdinhkem) {
          _err2 = errors.tentepdinhkem;
          _err2[index] = "Tên tệp không được trống";
        } else _err.push("Tên tệp không được trống");
        onError?.({
          ...errors,
          tepdinhkemValidate: _err,
          tentepdinhkem: _err2,
        });
        const updatedFields = [...fileFields];
        updatedFields[index].file = null;
        updatedFields[index].filename = null;
        onFileChange?.(updatedFields);
        return; // Dừng xử lý nếu định dạng không hợp lệ
      }
    }
    const updatedFields = [...fileFields];
    updatedFields[index].file = selectedFile;
    updatedFields[index].filename = selectedFile?.name;
    onFileChange?.(updatedFields);
  };
  const handleRemoveField = (index) => {
    const updatedFields = [...fileFields];
    updatedFields.splice(index, 1);
    onFileChange?.(updatedFields);
    let _err = [];
    if (errors && errors.tepdinhkemValidate) {
      _err = errors.tepdinhkemValidate;
      _err.splice(index, 1);
    } else _err.push("");
    let _err2 = [];
    if (errors && errors.tentepdinhkem) {
      _err2 = errors.tentepdinhkem;
      _err2.splice(index, 1);
    } else _err.push("");
    onError?.({ ...errors, tepdinhkemValidate: _err, tentepdinhkem: _err2 });
  };
  const handleAddField = () => {
    onFileChange?.([
      ...fileFields,
      { file: null, filename: null, remove: false },
    ]);
  };
  // const removeSubstrings = (str) => {
  //   const substrings = [
  //     "phieudangky_files/",
  //     "sanpham_files/",
  //     "chamdiem_files/",
  //     "phieuchamdiem_files/",
  //     "chutheocop_files/",
  //     "hoidong_files/",
  //     "vanban_files/",
  //     "hoidongchamdiem_files",
  //   ];
  //   const regex = new RegExp(substrings.join("|"), "g");
  //   return str.replace(regex, "");
  // };
  const listFileRemoveNameFile = useMemo(() => {
    let list = [];
    if (dataDefault?.length > 0) {
      list = dataDefault?.map((item) => ({
        ...item,
        tepdinhkem: item?.tepdinhkem,
        // tepdinhkem: removeSubstrings(item?.tepdinhkem),
      }));
    }
    return list;
  }, [dataDefault]);
  return (
    <>
      <Grid item xs={12} sx={{ textAlign: "left" }}>
        {!(listFileRemoveNameFile?.length > 0) &&
          !(fileFields?.filter((item) => !item?.remove)?.length > 0) && (
            <Typography
              sx={{
                textAlign: "center",
                borderBottom: "1px solid #d6d6d6",
                paddingBottom: "0.5rem",
                marginBottom: "0.5rem",
              }}
            >
              Không có thông tin tệp đính kèm
            </Typography>
          )}
        {listFileRemoveNameFile &&
          listFileRemoveNameFile?.length > 0 &&
          listFileRemoveNameFile?.map((file, index) => (
            <Grid
              container
              item
              xs={12}
              spacing={1}
              mt={0.5}
              direction="row"
              key={index}
            >
              {!Object.values(fileEditName).some(
                (item) => file?.id == item?.id
              ) ? (
                <>
                  <Grid item xs={1}>
                    <Typography variant="h5" color="info">
                      <Link
                        target="_blank"
                        href={API_URL_DOWNLOAD + checkUrlTep(file?.tepdinhkem)}
                      >
                        <DownloadIcon />
                      </Link>
                    </Typography>
                    {/* <IconDownload
                      filename={checkUrlTep(file?.tepdinhkem)}
                      onError={handleErrorDownload}
                      name={nameFile}
                      noMedia={noMedia}
                    /> */}
                  </Grid>
                  <Grid item xs={10} display={"flex"} alignItems={"center"}>
                    <Typography
                      fontSize={"1rem"}
                      style={{
                        textDecoration: fileDel.includes(file.id)
                          ? "line-through"
                          : "none",
                      }}
                    >
                      {file ? file.tentepdinhkem : "Tệp đính kèm id-" + file.id}
                    </Typography>
                  </Grid>
                </>
              ) : (
                <>
                  {!fileDel.includes(file.id) && (
                    <>
                      <Grid item xs={6}>
                        <TextField
                          fullWidth
                          required
                          id={"tentepdinhkemEdit" + index}
                          name="tentepdinhkemEdit"
                          error={
                            errors?.tentepdinhkemEdit &&
                            errors?.tentepdinhkemEdit[file?.id]
                              ? true
                              : false
                          }
                          helperText={
                            errors?.tentepdinhkemEdit &&
                            errors?.tentepdinhkemEdit[file?.id]
                              ? errors?.tentepdinhkemEdit[file?.id]
                              : ""
                          }
                          label="Tên tệp"
                          value={
                            fileEditName[file?.id]?.tentepdinhkem
                              ? fileEditName[file?.id]?.tentepdinhkem
                              : ""
                          }
                          onChange={handleEditFileName(file?.id)}
                          onFocus={handelFocusEditFileName(file?.id)}
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <TextField
                          fullWidth
                          fontSize={"1rem"}
                          value={
                            file
                              ? file.tepdinhkem
                              : "Tệp đính kèm id-" + file.id
                          }
                          disabled
                        />
                      </Grid>
                    </>
                  )}
                </>
              )}
              <Grid item xs={1} display={"flex"} justifyContent={"center"}>
                {!fileDel.includes(file.id) ? (
                  <>
                    {!Object.values(fileEditName).some(
                      (item) => file?.id == item?.id
                    ) && (
                      <IconButton
                        onClick={handleEditName(file.id, file.tentepdinhkem)}
                        sx={{ color: "#1A73E8", marginRight: 0 }}
                      >
                        <EditIcon />
                      </IconButton>
                    )}
                    {Object.values(fileEditName).some(
                      (item) => file?.id == item?.id
                    ) && (
                      <IconButton
                        onClick={handleToCancelEdit(file.id)}
                        sx={{ color: "#7b809a", marginRight: 0 }}
                      >
                        <ClearIcon />
                      </IconButton>
                    )}
                    <IconButton
                      edge="end"
                      aria-label="delete"
                      onClick={() => handelDelFile(file.id)}
                      sx={{ color: "red", marginRight: 0 }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </>
                ) : (
                  <IconButton
                    edge="end"
                    aria-label="delete"
                    onClick={() => handelRestoreFile(file.id)}
                    sx={{ color: "green", marginRight: 0 }}
                  >
                    <RedoIcon />
                  </IconButton>
                )}
              </Grid>
            </Grid>
          ))}
      </Grid>
      {fileFields &&
        fileFields.map((field, index) => (
          <div key={index}>
            <Grid
              container
              item
              xs={12}
              spacing={1}
              direction="row"
              sx={{
                textAlign: "center",
                mt: 0.5,
                display: field.remove ? "none" : "block-inline",
              }}
            >
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  required
                  disabled={field.remove}
                  id={"tentepdinhkem" + index}
                  // size="small"
                  name="tentepdinhkem"
                  error={
                    Array.isArray(errors?.tentepdinhkem) &&
                    errors?.tentepdinhkem?.length > 0
                      ? !!errors?.tentepdinhkem?.[index]
                      : false
                  }
                  helperText={
                    Array.isArray(errors?.tentepdinhkem) &&
                    errors?.tentepdinhkem?.length > 0
                      ? errors?.tentepdinhkem?.[index]
                      : ""
                  }
                  label="Tên tệp"
                  value={field.filename ? field.filename : ""}
                  onChange={(e) => handleFileNameChange(e, index)}
                  onFocus={handleOnFocusFileNameChange(index)}
                />
              </Grid>
              <Grid item xs={5}>
                <TextField
                  // type="file"
                  // size="small"
                  disabled={field.remove}
                  id={"tepdinhkem" + Math.random()}
                  placeholder="Chọn tệp đính kèm"
                  name="tepdinhkem"
                  error={
                    Array.isArray(errors.tepdinhkemValidate) &&
                    errors.tepdinhkemValidate.length > 0
                      ? !!errors.tepdinhkemValidate[index]
                      : false
                  }
                  helperText={
                    Array.isArray(errors.tepdinhkemValidate) &&
                    errors.tepdinhkemValidate.length > 0
                      ? errors.tepdinhkemValidate[index]
                      : ""
                  }
                  onChange={() => {}}
                  required={true}
                  onFocus={handleOnFocusFileChange(index)}
                  sx={{
                    width: "100%",
                  }}
                  value={field?.file?.name || ""}
                  InputProps={{
                    readOnly: true,
                    startAdornment: (
                      <InputAdornment position="start">
                        <Button
                          component="label"
                          variant="contained"
                          startIcon={<AttachFileIcon />}
                          style={{
                            color: "#121212",
                            paddingLeft: 0,
                            backgroundColor: "transparent",
                          }}
                          // size="small"
                          sx={{
                            "&.MuiButton-startIcon": {
                              margin: 0,
                            },
                            "&.MuiButton-root": {
                              height: "2rem",
                              boxShadow: "none",
                              padding: "1.35rem",
                            },
                          }}
                        >
                          {/* Thêm tệp */}
                          <VisuallyHiddenInput
                            type="file"
                            onChange={(e) => handleFileChange(e, index)}
                            // accept=".xlsx, .xls, image/*, .doc, .docx, .pdf, .zip, .rar"
                            accept={acceptFileTypes}
                          />
                        </Button>
                      </InputAdornment>
                    ),
                  }}
                ></TextField>
              </Grid>
              <Grid item xs={1}>
                <IconButton
                  aria-label="delete"
                  onClick={() => handleRemoveField(index)}
                  sx={{ color: "red", marginRight: "0" }}
                >
                  <DeleteIcon />
                </IconButton>
              </Grid>
            </Grid>
          </div>
        ))}
      <Grid container spacing={2} sx={{ mt: 0.1 }}>
        <Grid item xs={12}>
          <IconButton
            onClick={handleAddField}
            style={{
              backgroundColor: "rgb(156 199 255)",
              width: "100%",
              borderRadius: "5px",
            }}
          >
            <AddIcon
              style={{
                color: "white",
              }}
            />
          </IconButton>
        </Grid>
      </Grid>
    </>
  );
}
AddListFile.propTypes = {
  dataDefault: PropTypes.any,
  fileFields: PropTypes.any,
  fileDel: PropTypes.any,
  fileEditName: PropTypes.any,
  errors: PropTypes.any,
  onFileChange: PropTypes.func,
  onDelete: PropTypes.func,
  onEditName: PropTypes.func,
  onError: PropTypes.func,
  onErrorDownload: PropTypes.func,
  nameFile: PropTypes.string,
  noMedia: PropTypes.bool,
};
export default AddListFile;
